import _eol from "eol";
import _convertToPlainTextCustom from "../functions/quill/convertToPlainTextCustom.js";
import _convertToPlainText from "../functions/quill/convertToPlainText.js";
import _convertToHtml from "../functions/quill/convertToHtml.js";
import _getFormatOptions from "../functions/helpers/getFormatOptions.js";
import _removeInvalidEvents from "../functions/eventGroups/removeInvalidEvents.js";
import _tcLib from "../lib/timecode.js";
import _Event from "../classes/event.js";
const Event = _Event;
const tcLib = _tcLib;
const removeInvalidEvents = _removeInvalidEvents;
const getFormatOptions = _getFormatOptions;
const convertToHtml = _convertToHtml;
const convertToPlainText = _convertToPlainText;
const convertToPlainTextCustom = _convertToPlainTextCustom;
const eol = _eol;
function extractPositionData(text) {
  // Regular expression to match position data like {\anX}
  var positionRegex = /{\\an(\d+)}/;

  // Use the match method to find the position data
  var match = text.match(positionRegex);
  if (match) {
    // Extract the position value (X)
    var positionValue = parseInt(match[1]);
    return {
      hasPositionData: true,
      position: positionValue
    };
  } else {
    return {
      hasPositionData: false,
      position: null
    };
  }
}
let positionMap = {
  1: {
    x: "start",
    y: "end"
  },
  2: {
    x: "center",
    y: "end"
  },
  3: {
    x: "end",
    y: "end"
  },
  4: {
    x: "start",
    y: "center"
  },
  5: {
    x: "center",
    y: "center"
  },
  6: {
    x: "end",
    y: "center"
  },
  7: {
    x: "start",
    y: "start"
  },
  8: {
    x: "center",
    y: "start"
  },
  9: {
    x: "end",
    y: "top"
  }
};
let positionMapReverse = {
  "start": {
    "start": 7,
    "center": 4,
    "end": 1
  },
  "center": {
    "start": 8,
    "center": 5,
    "end": 2
  },
  "end": {
    "start": 9,
    "center": 6,
    "end": 3
  }
};
export default {
  decode: function (input, options) {
    let events = [],
      tcInfo;
    let subtitleBlocks = input.split("\n\n");
    subtitleBlocks.forEach(block => {
      let ccEvent = new Event({});
      let blockInfo = block.split("\n").filter(blockLine => {
        return blockLine !== "";
      });
      if (blockInfo.length > 1) {
        tcInfo = blockInfo.shift();
        let startTime = tcInfo.split(",")[0].trim();
        let endTime = tcInfo.split(",")[1].trim();

        //Sometimes the timecodes come in as `0:00:00.434` and need to be padded with `0`s to be `00:00:00.434`.
        startTime = startTime.padStart(12, "0");
        endTime = endTime.padStart(12, "0");
        ccEvent.start = tcLib.tcMsToSec(startTime, options.frameRate, options.dropFrame);
        ccEvent.end = tcLib.tcMsToSec(endTime, options.frameRate, options.dropFrame);
        let rawText = blockInfo.join("\n");
        try {
          let positionData = extractPositionData(rawText);
          if (positionData.hasPositionData) {
            ccEvent.xPos = positionMap[positionData.position] ? positionMap[positionData.position].x : "center";
            ccEvent.yPos = positionMap[positionData.position] ? positionMap[positionData.position].y : "end";
          }
        } catch (err) {
          console.log("Error parsing positiong data in SRT: ", err.message);
        }
        rawText = rawText.replace(/\\N$/gm, "").replace(/{\\an(\d+)}/gm, "");
        ccEvent.text = convertToHtml(rawText);
        events.push(ccEvent);
      }
    });
    // console.log(events);
    return events;
  },
  encode: function (eventGroup, options) {
    let output = "",
      errors = 0,
      encodingOptions = getFormatOptions(options.formatOptions);
    eventGroup.events.forEach(function (event, id) {
      try {
        let startMs = tcLib.secToTcMs(event.start, options.frameRate, options.dropFrame).replace(",", ".");
        let endMs = tcLib.secToTcMs(event.end, options.frameRate, options.dropFrame).replace(",", ".");
        //if the start and end times start with 00, we need to replace it with 0
        startMs = startMs.replace(/^00/, "0");
        endMs = endMs.replace(/^00/, "0");
        output += id + 1 - errors + "\n";
        output += startMs + "," + endMs + "\n";
        /* Encode Positioning if required */

        if (encodingOptions["Encode Positioning"] && encodingOptions["Encode Positioning"] != "false") {
          let xPos = event.xPos;
          let yPos = event.yPos;

          // Convert integer positions to flexbox values based on percentage
          if (typeof xPos === 'number') {
            const xPercentage = xPos / (options?.window?.width || 32);
            if (xPercentage <= 0.40) {
              xPos = "start";
            } else if (xPercentage >= 0.60) {
              xPos = "end";
            } else {
              xPos = "center";
            }
          }
          if (typeof yPos === 'number') {
            const yPercentage = yPos / (options?.window?.height || 15);
            if (yPercentage <= 0.20) {
              yPos = "start";
            } else if (yPercentage >= 0.50) {
              yPos = "end";
            } else {
              yPos = "center";
            }
          }

          // Default to center/end if position data is missing
          xPos = xPos || "center";
          yPos = yPos || "end";
          output += `{\\an${positionMapReverse[xPos][yPos]}}`;
        }
        if (encodingOptions["Encode Formatting"] && encodingOptions["Encode Formatting"] != "false") {
          output += convertToPlainTextCustom(event.text, "\n", false, "b", "i", "u") + "\n\n";
        } else {
          output += convertToPlainText(event.text) + "\n\n";
        }
      } catch (e) {
        console.log(e, e.message);
        errors++;
      }
    });
    return output.trim();
  },
  preProcess: {
    encode: function (eventGroup) {
      return removeInvalidEvents(eventGroup);
    },
    decode: function (input) {
      return eol.lf(input).trim().replace(/'(\n){3,}'/gim, "\n\n");
    }
  },
  postProcess: {
    encode: function (output) {
      return output.replace(new RegExp("(\n){3,}", "gim"), "\n\n").replace(/\n\n(?=\D)/gim, "\n").replace(/^ (?=.)/gm, '');
    },
    decode: function (eventGroup) {
      return eventGroup;
    }
  }
};